import React from 'react'

import classNames from 'classnames'
import DefaultLayout from '../../layout/default'

import CtaForm from '../../pagesSections/index/CtaForm'

import pageStyles from '../../styles/_V2/pagesStyles/styles.module.scss'
import styles from '../styles/_V2/docs.module.scss'
import AdaptiveLink from '../../components/AdaptiveLink'
import {pagesLinks} from '../../pages-data/common/links'
import { useLocalizationContext } from "../../localization/useLocalizationContext";
import {externalLinks} from "../../pages-data/_V2/common/links";

export default function PagePrivacyPolicy() {

    const localizationContext = useLocalizationContext()

    const metaUrl = {
        'ru-RU': `${externalLinks.quickrestoRU.href}licenseAgreement/`,
        'ru-KZ': `${externalLinks.quickrestoKZ.href}licenseAgreement/`,
        'kz-KZ': `${externalLinks.quickrestoKZ.href}licenseAgreement/`,
        'ru-BY': `${externalLinks.quickrestoBY.href}licenseAgreement/`,
    }
    const currentCanonicalLink = metaUrl[localizationContext.locale]

    const metaTags = [
        {
            name: 'description',
            content: 'Лицензионный договор является офертой ООО «Квик Ресто» — система автоматизации предприятий общественного питания Quick Resto — программа для полноценного складского учёта в общепите онлайн, удобный кассовый терминал на планшете, CRM и настраиваемая система отчетов.',
        },
        {
            property: 'og:url',
            content: currentCanonicalLink,
        },
        {
            property: 'og:title',
            content: 'Лицензионный договор на право использования системы автоматизации Quick Resto',
        },
        {
            property: 'og:description',
            content: 'Лицензионный договор является офертой ООО «Квик Ресто» — система автоматизации предприятий общественного питания Quick Resto — программа для полноценного складского учёта в общепите онлайн, удобный кассовый терминал на планшете, CRM и настраиваемая система отчетов.',
        },
        {
            property: 'og:type',
            content: 'website',
        },
    ]

    if (localizationContext.locale === 'ru-BY') {

        return (
            <DefaultLayout
                title="Сублицензионный договор на право использования программы для ЭВМ Quick Resto"
                metaTags={metaTags}
                mainWrapperClassName={classNames(
                    pageStyles.pageWrapper,
                    pageStyles.pageGray,
                    styles.docs,
                )}
                linkCanonical="https://quickresto.by/licenseAgreement/"
                footerClassName={pageStyles.pageSection}
            >
                <section
                    className={classNames(styles.docs__container, pageStyles.pageSection)}
                >
                    <div className={styles.docs__content}>
                        <h1 className={styles.bigMb}>Сублицензионный договор</h1>

                        <div>
                            <p>
                                Сублицензионный договор на право использования программы для ЭВМ
                                «Система автоматизации предприятий общественного питания «Quick
                                Resto»
                            </p>

                            <p>
                                Индивидуальный предприниматель Дятлов К.В., именуемый в дальнейшем
                                «Лицензиат», действующий на основании Свидетельства о регистрации ИП, с одной
                                стороны, а с другой стороны любое лицо, пользователь услуг сайта www.quickresto.by,
                                именуемый в дальнейшем «Сублицензиат», принявшее (акцептовавшее) публичное
                                предложение (оферту) Лицензиата, совершая действия, означающие присоединение в целом
                                ко всем условиям настоящего Договора о нижеследующем:
                            </p>
                        </div>

                        <div>
                            <p>1. Термины и определения</p>

                            <p>1.1. В Договоре используются следующие термины и их определения:</p>

                            <p> 1.1.1. запрос – требования субъекта персональных данных, касающиеся обработки
                                персональных данных;</p>

                            <p>1.1.2. идентификация – процедура установления правомерности обращения
                                Сублицензиата к серверу Лицензиата. Осуществляется на основании логина и/или пароля
                                и/или иного кода доступа. Порядок идентификации определяется выбранным Сублицензиатом
                                тарифным планом;</p>

                            <p>1.1.3. лицензионный договор – лицензионный договор на право использования
                                Программы от 18.10.2021, заключенный между Лицензиатом и лицензиаром ООО
                                «КвикРесто» (ИНН 7726734798, КПП 772401001, 117105, г. Москва, Варшавское шоссе, д. 35,
                                стр. 1, этаж 7, ч. ком. 10), являющимся правообладателем Программы;</p>

                            <p>1.1.4. лицензия – простое (неисключительное) разрешение на право использования
                                Программы в объеме и пределах, установленных настоящим Договором и Тарифным планом
                                с сохранением за Лицензиатом права выдачи лицензий другим лицам;</p>

                            <p>1.1.5. облачный бэк-офис («облако») – панель управления Программой, находящаяся и
                                доступная на выделенном для использования Сублицензиатом домене
                                http://адрес_бэкофиса.quickresto.ru,
                                доступ к которому предоставляется Лицензиатом;</p>

                            <p>1.1.6. прайс-лист – документ, устанавливающий размеры вознаграждения Лицензиату
                                в зависимости от Тарифного плана и срока, на который предоставляется Лицензия, а также
                                содержащий сведения о функциональных возможностях Программы. Действующая редакция
                                документа опубликована на сайте www.quickresto.by;</p>

                            <p>1.1.7. программа – компьютерный программный продукт «Система автоматизации
                                предприятий общественного питания «Quick Resto», право использования которым
                                (лицензия) предоставлено Лицензиату по лицензионному договору. Программа является
                                объектом авторского права, подлежащим правовой охране в соответствии с
                                законодательством Республики Беларусь и международными договорами, использование
                                которого третьими лицами (пользователями) осуществляется на основании
                                гражданско-правового договора;</p>

                            <p>1.1.8. сублицензиат (конечный пользователь) – юридическое или физическое лицо,
                                которому предоставлено право использования Программы на условиях настоящего договора
                                без права передачи третьим лицам разрешения на использование Программы;</p>

                            <p>1.1.9. субъект персональных данных – физическое лицо, персональные данные
                                которого Сублицензиат обрабатывает с использованием Программы.</p>

                            <p>1.1.10. тарифный план – неотъемлемая часть Прайс-листа, содержащая описание
                                Программы, включающее в себя описание объема предоставляемых Сублицензиату прав на
                                использование Программы и доступных ему функций Программы.</p>

                            <p>1.2. Все остальные термины и их определения применяются Сторонами в соответствии
                                с законодательством Республики Беларусь и международными договорами.</p>
                        </div>
                        <div>
                            <p>2. Предмет договора</p>

                            <p>2.1. Лицензиат за вознаграждение предоставляет Сублицензиату в объеме и пределах,
                                установленных настоящим Договором и Тарифным планом, простую (неисключительную)
                                лицензию на право использования Программы на территории Республики Беларусь в
                                качестве ее конечного пользователя путем открытия доступа к серверу Лицензиата.
                                2.2. Описание Программы содержится на Интернет-сайтах www.quickresto.by,
                                www.quickresto.ru. Совершая действия, означающие присоединение ко всем условиям
                                Договора (акцепт), Сублицензиат подтверждает, что ознакомлен с описанием Программы в
                                полном объеме.</p>

                            <p>2.3. Программа предназначена исключительно для коммерческого использования и не
                                может использоваться в целях, не связанных с предпринимательской деятельностью.
                                Присоединяясь к условиям настоящего Договора, Сублицензиат - физическое лицо
                                подтверждает, что приобретает лицензию на Программу не для личного использования.</p>

                            <p>2.4. Сублицензиат как конечный пользователь получает право использовать Программу
                                по ее прямому назначению в объеме и пределах, установленных настоящим Договором и
                                Тарифным планом и в соответствии с функциональными возможностями Программы,
                                определенными в технической документации.</p>

                            <p>2.5. Сублицензиат может использовать Программу следующими способами: 2.5.1.
                                круглосуточно получать доступ к серверу Лицензиата, за исключением времени проведения
                                профилактических работ, и воспроизводить графическую часть (рабочий интерфейс) на
                                экране персонального компьютера;</p>

                            <p>2.5.2. использовать все функциональные возможности Программы, описанные
                                Тарифным планом в Прайс-листе Лицензиата;</p>

                            <p>2.5.3. размножать документацию для личного использования.</p>

                            <p>2.6. Возможность использовать Программу для подготовки, хранения и передачи
                                данных предоставляется только Сублицензиату. Сублицензиат не имеет права выдавать
                                сублицензии на Программу, а также предоставлять право ее использования третьим лицам
                                иным способом.</p>

                            <p>2.7. Все условия настоящего Договора в равной степени применяются к Программе в
                                целом и к ее компонентам в отдельности, включая все обновления Программы. 2.8. Все
                                исключительные права на Программу сохраняются за правообладателем. Стороны при
                                заключении Договора и исполнении его условий исходят из того, что Лицензиат не является
                                разработчиком и правообладателем Программы.</p>

                            <p>2.9. Срок действия Лицензии определяется выбранным Сублицензиатом Тарифным
                                планом. По истечении срока действия Лицензия возобновляется автоматически на тот же срок
                                и в том же объеме при условии ее 100% предоплаты.</p>
                        </div>
                        <div>
                            <p>3. Условия получения лицензии на программное обеспечение
                                «БРЕНДИРОВАННОЕ МОБИЛЬНОЕ ПРИЛОЖЕНИЕ»</p>

                            <p>3.1. За дополнительное вознаграждение Лицензиат предоставляет Сублицензиату
                                простую (неисключительную) лицензию на программное обеспечение «Брендированное
                                мобильное приложение» (далее – Брендированное мобильное приложение, Мобильное
                                приложение), которое Лицензиат в соответствии с требованиями Сублицензиата адаптирует
                                под его деятельность для использования Мобильного приложения клиентами Сублицензиата
                                (потребителями его товаров, работ, услуг).</p>

                            <p>3.2. Приобретение Сублицензиатом лицензии на Мобильное приложение является его
                                правом, а не обязанностью.</p>

                            <p>3.3. Условия приобретения лицензии на использование Мобильного приложения
                                содержатся в Приложении № 1 к настоящему сублицензионному договору. На указанное
                                Приложение № 1 распространяются все условия настоящего сублицензионного договора в
                                части, не противоречащей Приложению № 1.</p>

                            <p>3.4. Краткое описание программы для ЭВМ «Брендированное мобильное приложение»
                                и её возможностей, а также преимуществ ее использования содержится по следующей
                                интернет ссылке: https://quickresto.ru/capability.</p>
                        </div>
                        <div>
                            <p>4. Порядок заключения договора</p>

                            <p>4.1. Настоящий Договор является публичным (статья 396 Гражданского кодекса
                                Республики Беларусь (далее – ГК)). Публикация (размещение) текста Договора на сайте
                                Лицензиата по адресу: www.quickresto.by является публичным предложением (офертой)
                                Лицензиата заключить Договор с любым, кто отзовется (статья 405 и пункт 2 статьи 407
                                ГК).</p>

                            <p>4.2. Фактом принятия (акцепта) Сублицензиатом условий настоящего Договора
                                является внесение вознаграждения за лицензию по выбранному им Тарифному плану.
                                Настоящий Договор, при условии соблюдения порядка его акцепта, считается заключенным в
                                простой письменной форме (пункты 2, 3 статьи 404 и пункт 3 статьи 408 ГК)</p>

                            <p>4.3. Стороны соглашаются, что Договор заключен по месту нахождения Лицензиата.</p>
                        </div>
                        <div>
                            <p>5. Лицензионное возграждение. Порядок расчетов</p>

                            <p>5.1. В разумный срок после выбора Сублицензиатом Тарифного плана и сообщения об
                                этом Лицензиату последний направляет счёт на оплату лицензионного вознаграждения (далее
                                – Счет). Сумма, указанная в счёте, определяется на основании действующего Прайс листа и
                                порядка применения скидок. Действующим является Прайс-лист, опубликованный на сайте
                                Лицензиата в момент направления счёта Сублицензиату.</p>

                            <p>5.2. Счет на оплату с факсимильной подписью и печатью Лицензиата направляется на
                                адрес электронной почты Сублицензиата, указанный им при регистрации на сайте
                                Лицензиата. Также Счет может выставляться путем размещения на Интернет-сайте
                                Лицензиата. Оплачивая Счет, Сублицензиат подтверждает, что принял все условия, в нем
                                содержащиеся, а также что присоединяется ко всем условиям настоящего публичного
                                Договора в целом, без каких-либо изъятий и оговорок (статья 398 ГК).</p>

                            <p>5.3. Внесение лицензионного вознаграждения осуществляется на основе
                                стопроцентной предоплаты и в порядке, устанавливаемом настоящим Договором.
                                Сублицензиату не предоставляется Лицензия до момента ее полной оплаты. Датой внесения
                                вознаграждения и заключения настоящего Договора признаётся дата зачисления денежных
                                средств на расчётный счёт Лицензиата, при условии идентификации платежа Сублицензиата
                                путем указания в платежном документе номера и даты Счёта.</p>

                            <p>5.4. В дальнейшем Сублицензиат уплачивает Лицензиату лицензионное
                                вознаграждение ежемесячно не позднее 1 (первого) числа месяца, следующего за отчетным, в
                                размере, предусмотренным Тарифным планом на основании Счетов, выставленных
                                Лицензиатом. Счет считается выставленным и полученным в день направления на адрес
                                электронной почты Сублицензиата, указанный им при регистрации на сайте Лицензиата либо
                                в день размещения его на сайте Лицензиата.</p>

                            <p>5.5. В случае внесения лицензионного вознаграждения позднее первого числа месяца
                                его размер остается неизменным, а срок предоставляемой Лицензии уменьшается на
                                количество неоплаченных дней в этом месяце и заканчивается в последний день месяца
                                уплаты лицензионного вознаграждения, независимо от даты его внесения.</p>

                            <p>5.6. Все банковские либо иные комиссионные платежи, связанные с уплатой
                                лицензионного вознаграждения, несет Сублицензиат.</p>

                            <p>5.7. При изменении Прайс-листа Лицензиат обязан уведомить об этом Сублицензиата
                                путем размещения нового Прайс-листа на сайте www.quickresto.by в разделе «Цены» не
                                позднее 7 календарных дней до вступления его в силу. Также он вправе направить новый
                                Прайс-лист на адрес электронной почты Сублицензиата, указанный им при регистрации на
                                сайте Лицензиата.</p>

                            <p>5.8. В случае невыплаты лицензионного вознаграждения в указанный срок Лицензиат
                                вправе заблокировать доступ к облачному бэк-офису («облаку») Сублицензиата до момента
                                фактической уплаты лицензионного вознаграждения. При этом Лицензиат не несет
                                ответственности за любые убытки, связанные с блокировкой доступа к облачному бэк-офису
                                («облаку») Сублицензиата по причине несвоевременной оплаты им лицензионного
                                вознаграждения за право использования Программы, в том числе и в случае, если Лицензиат
                                был предупрежден о возможности появления таких убытков в следствие блокировки доступа
                                к облачному бэк-офису («облаку»).</p>

                            <p>5.9. Сублицензиат не вправе в одностороннем порядке уменьшить ранее выбранный им
                                период использования Программы и определяемый в соответствии с этим периодом размер
                                лицензионного вознаграждения. В случае, если по причинам, зависящим от Сублицензиата,
                                длительность использования Программы фактически оказалась меньше, чем срок, на который
                                Сублицензиат изначально приобрел право пользования Программой, размер лицензионного
                                вознаграждения уменьшению не подлежит.</p>

                            <p>5.10. Доступ к Программе предоставляется в течение 5 дней с момента поступления
                                лицензионного вознаграждения на счет Лицензиата.</p>

                            <p>5.11. Факт оказания услуги (активации лицензии) Сублицензиату подтверждается
                                Актом о передаче лицензии, который составляется Лицензиатом единолично.</p>

                            <p>5.12. По выбору Лицензиата Акт о передаче лицензии также может быть подписан и
                                направлен Сублицензиату для подписания одним из следующих способов: 5.12.1.
                                изготовленный на бумажном носителе Акт о передаче лицензии подписывается
                                руководителем Лицензиата или уполномоченным лицом, действующим на основании
                                доверенности, и направляется Сублицензиату по почте;</p>

                            <p>5.12.2. изготовленный на электронном носителе Акт о передаче лицензии
                                подписывается факсимильной подписью руководителя Лицензиата и направляется
                                Сублицензиату по электронной почте или размещается на сайте Лицензиата;</p>

                            <p>5.12.3. изготовленный на электронном носителе Акт о передаче лицензии
                                подписывается электронно-цифровой подписью Лицензиата и направляется Сублицензиату
                                по электронной почте или размещается на сайте Лицензиата.</p>

                            <p>5.13. Сублицензиат безоговорочно соглашается с тем, что если он в течение пяти
                                календарных дней с момента составления или направления Акта о передаче лицензии не
                                заявит каких-либо письменных претензий в связи с активацией ему Лицензии, то это
                                рассматривается как его однозначное согласие с тем, что Лицензия была передана
                                Лицензиатом своевременно, надлежащим образом и в полном объеме прав согласно Договору,
                                Прайс-листу и Тарифному плану.</p>

                            <p>5.14. В случае активации Программы и последующего отказа Сублицензиата от ее
                                использования по любым причинам возврат оплаченного лицензионного вознаграждения не
                                производится.</p>
                        </div>
                        <div>
                            <p>6. Права, обязанности и гарантии сторон</p>

                            <p>6.1. Лицензиат обязан:</p>

                            <p>6.1.1. публиковать на своем сайте уведомления об изменениях условий настоящего
                                Договора и/или сообщать о них на электронную почту Сублицензиата, указанную им при
                                регистрации на сайте Лицензиата;</p>

                            <p>6.1.2. обеспечить соответствие Программы функциональным и техническим
                                параметрам, указанным в приложении к Прайс-листу «Перечень функциональных
                                возможностей»;</p>

                            <p>6.1.3. за исключением времени проведения профилактических работ, обеспечивать
                                круглосуточную доступность сервера и Программы в соответствии с выбранным
                                Сублицензиатом Тарифным планом при условии оплаты лицензионного вознаграждения;</p>

                            <p>6.1.4. сообщать через сайт и/или по электронной почте о проведении
                                профилактических работ на сервере и/или приостановлении работы сайта, на котором
                                расположена Программа, не позднее одного рабочего дня до момента проведения таких
                                работ;</p>

                            <p>6.1.5. обеспечивать целостность и сохранность на сервере данных, введенных
                                Сублицензиатом в Программу, до прекращения настоящего Договора или до момента
                                получения уведомления от Сублицензиата о необходимости уничтожения таких данных;</p>

                            <p>6.1.6. обеспечить конфиденциальность данных, размещенных Сублицензиатом в
                                Программе, на весь период их нахождения на сервере Лицензиата.</p>

                            <p>6.1.7. безвозмездно устранять в Программе ошибки и иные недостатки в случае их
                                обнаружения;</p>

                            <p>6.1.8. по заявке Сублицензиата организовать и провести обучение навыкам работы с
                                Программой работников Сублицензиата на основании отдельного договора. Оплата такого
                                обучения не может рассматриваться как лицензионное вознаграждение в рамках Договора;</p>

                            <p>6.1.9. осуществлять техническую поддержку использования Программы
                                Сублицензиатом путем осуществления консультирования работников Сублицензиата по
                                телефону, адресам электронной почты, в программах-месcенджерах, указанных на Интернет
                                сайтах www.quickresto.by, www.quickresto.ru в разделе «Поддержка». Осуществление
                                технической поддержки включено в лицензионное вознаграждение и дополнительно
                                Сублицензиатом не оплачивается.</p>

                            <p>6.2. Лицензиат имеет право:</p>

                            <p>6.2.1. изменять Программу или выпускать ее новую версию в любое время и по любой
                                причине, в том числе в целях удовлетворения потребностей Сублицензиата или требований
                                конкурентоспособности, в целях соблюдения действующего законодательства Республики
                                Беларусь. Лицензиат оставляет за собой право добавлять новые свойства и функциональные
                                возможности Программы или удалять из Программы уже существующие свойства и
                                функциональные возможности;</p>

                            <p>6.2.2. блокировать доступ к Программе при нарушении Сублицензиатом условий
                                Договора;</p>

                            <p>6.2.3. размещать на документах и файлах, созданных в процессе использования
                                Программы, информацию о том, что такие документы и файлы созданы с помощью
                                Программы;</p>

                            <p>6.2.4. размещать в Программе рекламу профессиональных услуг и товаров, которые по
                                мнению Лицензиата будут полезны для Сублицензиата;</p>

                            <p>6.2.5. использовать наименование и логотип/товарный знак Сублицензиата в
                                маркетинговых и рекламных материалах Лицензиата по своему усмотрению; 6.2.6.
                                пользоваться услугами любых физических и юридических лиц, в целях своевременного и
                                качественного исполнения обязательств по Договору. 6.3. Сублицензиат обязан:</p>

                            <p>6.3.1. ознакомиться с инструкциями по работе с Программой, в том числе с перечнем
                                совместимого с Программой оборудования и прочей информацией, необходимой для
                                нормальной работы с Программой на сайтах www.quickresto.by, www.quickresto.ru;</p>

                            <p>6.3.2. не копировать, не модифицировать, не декомпилировать, не деассемблировать
                                Программу;</p>

                            <p>6.3.3. не предоставлять третьим лицам доступ к информации, хранящейся в
                                Программе, за исключением случаев обработки персональных данных, осуществляемой
                                Сублицензиатом в соответствии с настоящим Договором;</p>

                            <p>6.3.4. своевременно направлять Лицензиату уведомления о необходимости
                                уничтожения данных на сервере;</p>

                            <p>6.3.5. представлять Лицензиату все сведения и документы, необходимые для
                                выполнения им своих обязательств по настоящему Договору;</p>

                            <p>6.3.6. обеспечивать конфиденциальность кодов аутентификации, при их наличии;</p>

                            <p>6.3.7. информировать Лицензиата обо всех изменениях персональных данных или сведений
                                о юридическом лице (изменение фамилии/наименования, адреса, банковских реквизитов), не
                                позднее одного месяца с момента таких изменений. При этом Сторонам не требуется
                                заключать дополнительное соглашение. Все негативные последствия неисполнения
                                обязанности по извещению в рамках настоящего пункта несет Сублицензиат; 6.4.
                                Сублицензиат имеет право:</p>

                            <p>6.4.1. получать круглосуточный доступ к серверу, за исключением времени проведения
                                профилактических работ;</p>

                            <p>6.4.2. вносить предложения по изменению функциональных возможностей
                                Программы;</p>

                            <p>6.4.3. в любой момент изменить Тарифный план. В случае если стоимость нового Тарифного
                                плана превышает стоимость действующего, то доступ к новому Тарифному плану
                                производится после доплаты разницы между новым и действующим Тарифным планом. В
                                случае если стоимость нового Тарифного плана меньше стоимости действующего Тарифного
                                плана, то разница в размере лицензионного вознаграждения Сублицензиату не
                                возвращается;</p>

                            <p>6.5. Лицензиат гарантирует наличие у него необходимых имущественных прав на
                                распространение Программы, в том числе на заключение (суб)лицензионных договоров
                                (неисключительных (суб)лицензий) на передачу неисключительных прав использования
                                Программы конечным пользователям на территории Республики Беларусь на основании
                                договора с правообладателем. Лицензиат гарантирует, что права на Программу не заложены,
                                не арестованы и не являются предметом иска третьих лиц.</p>

                            <p>6.6. Лицензиат гарантирует, что:</p>

                            <p>6.6.1. им приняты необходимые организационные и технические меры для защиты
                                персональных данных от неправомерного или случайного доступа к ним, уничтожения,
                                изменения, блокирования, копирования, распространения персональных данных, а также от
                                иных неправомерных действий в отношении персональных данных, в частности:
                                - определение угроз безопасности персональных данных при их обработке; -
                                установление правил доступа к обрабатываемым персональным данным; - обнаружение
                                фактов несанкционированного доступа к персональным данным и принятие мер по их
                                пресечению;
                                - проведение оценки эффективности принимаемых мер по обеспечению безопасности
                                персональных данных и контроля за принимаемыми мерами;</p>

                            <p>6.6.2. при передаче данных по телекоммуникационным каналам связи им применяются
                                средства криптографической защиты информации.</p>

                            <p>6.7. Сублицензиат, присоединяясь к условиям настоящего Договора, гарантирует
                                Лицензиату, что:</p>

                            <p>6.7.1. указал достоверные данные при регистрации на Интернет-сайтах
                                www.quickresto.by, www.quickresto.ru и при оформлении платежных документов по внесению
                                лицензионного вознаграждения;</p>

                            <p>6.7.2. заключает Договор добровольно, полностью ознакомился с условиями Договора
                                и его неотъемлемых частей и полностью понимает его предмет;</p>

                            <p>6.7.3. обладает всеми правами и полномочиями, необходимыми для заключения и
                                исполнения Договора;</p>

                            <p>6.7.4. при размещении персональных данных им соблюдены все права, ограничения и
                                условия обработки персональных данных, предусмотренные действующим
                                законодательством Республики Беларусь, в том числе получено согласие субъектов
                                персональных данных на обработку принадлежащих им данных с использованием
                                Программы;</p>

                            <p>6.7.5. в случае прекращения действия Договора им самостоятельно в течение 10
                                (десяти) рабочих дней будут уничтожены персональные данные, размещенные в Программе,
                                либо направлено своевременное уведомление Лицензиату о необходимости такого
                                удаления.</p>

                            <p>6.8. Заключая настоящий Договор, Сублицензиат-физическое лицо дает согласие на
                                сбор, хранение своих персональных данных Лицензиату и (или) третьим лицам и их
                                обработку Лицензиатом и (или) третьими лицами.</p>
                        </div>
                        <div>
                            <p>7. Ответственность сторон</p>

                            <p>7.1. За неисполнение либо ненадлежащее исполнение своих обязательств по Договору
                                виновная Сторона несет ответственность в соответствии с законодательством Республики
                                Беларусь, с учетом особенностей, установленных настоящим Договором.</p>

                            <p>7.2. Лицензиат предоставляет Сублицензиату Программу в соответствии с
                                общепринятым в международной практике принципом и обычаем делового оборота «как
                                есть» («as is») и не несет ответственности за проблемы и недостатки, возникающие и/или
                                обнаруживаемые в процессе обновления, поддержки и эксплуатации Программы (включая без
                                ограничения проблемы совместимости с другими программными продуктами, драйверами,
                                оборудованием и др., несоответствие результатов использования Программы ожиданиям
                                Сублицензиата и т. д.). Сублицензиат несет риск соответствия Программы, условий и объема
                                предоставляемого права своим желаниям и потребностям.</p>

                            <p>7.3. Лицензиат не несет ответственности за прямые или косвенные убытки, включая
                                упущенную выгоду, возникшие в результате применения Программы.</p>

                            <p>7.4. Лицензиат не несет ответственности за невозможность использования Программы
                                по причинам, от него не зависящим, в том числе за прямые и/или косвенные убытки
                                Сублицензиата в результате:</p>

                            <p>7.4.1. неправомерных действий пользователей сети Интернет;</p>

                            <p>7.4.2. отсутствия и/или наличия проблем при установлении Интернет-соединения
                                между оборудованием Сублицензиата и сервером Лицензиата;</p>

                            <p>7.4.3. проведения органами государственной власти оперативно-розыскных
                                мероприятий, если проведение таких мероприятий не вызвано осуществлением Лицензиатом
                                противоправной деятельности, подтвержденным вступившим в законную силу решением
                                суда;</p>

                            <p>7.4.4. незаконного ограничения доступа к сайту Лицензиата третьими лицами. 7.5.
                                Лицензиат не несет ответственности за обеспечение достоверности, полноты, точности и
                                актуальности персональных данных, размещенных Сублицензиатом. Все полученные от
                                Сублицензиата персональные данные обрабатываются в том виде, как они были получены.</p>

                            <p>7.6. Лицензиат не несет ответственности за несоблюдение Сублицензиатом
                                организационных и иных мер, приведшее к неправомерному или случайному доступу к
                                персональным данным лиц, не уполномоченных Сублицензиатом на обработку персональных
                                данных, а также повлекшее их уничтожение, изменение, блокирование, копирование или
                                распространение, а также иные неправомерные действия со стороны работников
                                Сублицензиата и/или третьих лиц.</p>

                            <p>7.7. В случае неисполнения Сублицензиатом обязанности уничтожить персональные
                                данные, размещенные в Программе, в течение 10 рабочих дней с момента прекращения
                                действия настоящего договора, Лицензиат вправе уничтожить персональные данные.</p>

                            <p>7.8. Лицензиат не может гарантировать работоспособность Программы и не несет за
                                это ответственность в случае, если у Сублицензиата отсутствует последняя версия
                                (своевременное обновление) необходимого программного обеспечения.</p>

                            <p>7.9. Сублицензиат самостоятельно несет полную ответственность за любые, в том
                                числе и несанкционированные, действия третьих лиц, имевших место вследствие
                                несоблюдения Сублицензиатом конфиденциальности своих учетных данных или иной
                                информации закрытого характера, а также за последствия таких действий.</p>

                            <p>7.10. Сублицензиат несет ответственность за достоверность сведений, указанных им
                                при регистрации на сайте Лицензиата и достоверность гарантий Сублицензиата,
                                содержащихся в настоящем Договоре.</p>

                            <p>7.11. В случае нарушения сроков выплаты лицензионного вознаграждения Лицензиат
                                имеет право направить Сублицензиату уведомление о приостановлении права на
                                использование Программного продукта в письменной форме до момента надлежащего
                                исполнения платежных обязательств. С даты, указанной Лицензиатом в уведомлении,
                                Лицензиат приостанавливает действие лицензии на право использования Программы.</p>

                            <p>7.12. В случае просрочки выплаты лицензионного вознаграждения более чем на 15
                                (пятнадцать) календарных дней Лицензиат вправе в одностороннем внесудебном порядке
                                отказаться от исполнения Договора путем направления Сублицензиату уведомления в
                                письменной форме. Договор считается расторгнутым с даты, указанной Лицензиатом в
                                уведомлении.</p>

                            <p>7.13. Ответственность сторон за нарушение обязательств по настоящему Договору
                                определяется также и иными положениями настоящего Договора.</p>

                            <p>7.14. Стороны освобождаются от ответственности за неисполнение либо
                                ненадлежащее исполнение своих обязательств по настоящему Договору, если невозможность
                                их выполнения обусловлена действием непреодолимой силы. Свидетельство, выданное
                                торговой палатой или иным компетентным органом, является достаточным подтверждением
                                наличия и продолжительности действия обстоятельств непреодолимой силы.</p>
                        </div>
                        <div>
                            <p>8. Извещения и уведомления</p>

                            <p>8.1. Стороны договариваются, что безоговорочно признают юридическую силу текстов
                                документов и переписки, полученных по каналам факсимильной связи и/или электронным
                                способом наравне с документами, исполненными в простой письменной форме на бумажном
                                носителе. В том числе Стороны признают юридическую силу документов, подписанных
                                факсимильной подписью или электронно-цифровой подписью (пункт 2 статьи 161 ГК).</p>

                            <p>8.2. Стороны безоговорочно соглашаются с тем, что вся переписка, извещения и
                                уведомления, направленные на адреса электронной почты, указанные как реквизиты
                                Лицензиата в настоящем Договоре и при регистрации Сублицензиата на сайте Лицензиата,
                                считаются доставленными адресату в надлежащей форме. Сублицензиат вправе изменить
                                контактный адрес электронной почты, направив Лицензиату соответствующее заявление с
                                адреса электронной почты, ранее указанного, как контактный, либо предоставив заявление
                                на
                                бумажном носителе со своей подписью.</p>

                            <p>8.3. Стороны обязуются обеспечить доступ к адресам своей электронной почты только
                                лицам, уполномоченным принимать решения по Договору. Стороны обязаны своевременно
                                проверять корреспонденцию, поступающую на их адреса электронной почты.
                                Все риски, связанные с наступлением неблагоприятных последствий вследствие
                                несоблюдения требований настоящего пункта Договора, несет Сторона, допустившая такое
                                нарушение.</p>
                        </div>
                        <div>

                            <p>9. Порядок рассмотрения споров</p>

                            <p>9.1. Стороны будут стремиться к разрешению всех возможных споров и разногласий
                                путем переговоров и в претензионном порядке. Срок рассмотрения претензии составляет 10
                                календарных дней с момента ее получения. Стороны признают отсутствие (ненаправление)
                                ответа на претензию в течение указанного срока согласием с изложенными в ней
                                обстоятельствами и требованиями, в том числе с размером и основаниями задолженности.</p>

                            <p>9.2. Споры, не урегулированные путем переговоров или в претензионном порядке,
                                передаются на рассмотрение в соответствии с действующим законодательством Республики
                                Беларусь по месту нахождения Лицензиата.</p>

                            <p>9.3. В случае, если какое-либо из условий Договора потеряет юридическую силу, будет
                                признанно незаконным, или будет исключено из Договора, то это не влечет
                                недействительность остальных условий Договора, которые сохранят юридическую силу и
                                являются, обязательными для исполнения Сторонами.</p>
                        </div>
                        <div>
                            <p>10. Срок действия договора. Изменение и расторжение договора</p>

                            <p>10.1. Настоящий Договор вступает в силу с момента принятия Сублицензиатом его
                                условий и действует в течение срока, установленного Тарифным планом. Договор
                                автоматически пролонгируется на новый срок на условиях выбранного Сублицензиатом
                                Тарифного плана.</p>

                            <p>10.2. Договор размещается на сайте Лицензиата. Лицензиат оставляет за собой право
                                внести изменения, дополнения в условия Договора или принять Договор в новой редакции в
                                любой момент по своему усмотрению. Названные изменения вступают в силу с момента
                                размещения измененного текста Договора на сайте Лицензиата, если иной срок вступления
                                изменений в силу не определен дополнительно при таком размещении.</p>

                            <p>10.3. В случае своего несогласия с внесенными изменениями, дополнениями или
                                новой редакцией Договора, Сублицензиат имеет право расторгнуть Договор путем
                                направления по месту нахождения Лицензиата заказным письмом с обратным уведомлением
                                письменного уведомления о расторжении Договора. Договор будет считаться расторгнутым
                                по истечении 10 (десяти) календарных дней с момента получения указанного уведомления
                                Лицензиатом.</p>

                            <p>10.4. Стороны безоговорочно соглашаются с тем, что молчание (отсутствие
                                письменных уведомлений о расторжении Договора, либо о несогласии с отдельными
                                положениями Договора, в том числе с изменением Прайс-листа, Тарифного плана) признается
                                согласием и присоединением Сублицензиата к новой редакции Договора или его
                                неотъемлемый частей (пункт 3 статьи 159 ГК).
                            </p>
                            <p>10.5. Лицензиат вправе отказаться от исполнения настоящего Договора в
                                одностороннем порядке при нарушении Сублицензиатом его условий, уведомив его не
                                позднее 10 (десяти) календарных дней до даты расторжения Договора. В этом случае Договор
                                расторгается по окончанию срока Лицензии.</p>

                            <p>10.6. В случае досрочного прекращения настоящего Договора по любой причине
                                уплаченное Сублицензиатом лицензионное вознаграждение не подлежит возврату. 10.7.
                                Прекращение настоящего Договора не освобождает Стороны от ответственности за его
                                нарушение.</p>
                        </div>
                        <div>
                            <p>11. Прочие условия</p>

                            <p>11.1. Заключая настоящий Договор, Сублицензиат дает согласие на получение
                                дополнительной информации и информационных рассылок по указанному при регистрации
                                адресу и телефону.</p>

                            <p>11.2. Заключая Договор, Сублицензиат подтверждает наличие у него законных
                                оснований для обработки с использованием Программы принадлежащей ему информации, в
                                том числе персональных данных.</p>

                            <p>11.3. Настоящий Договор составлен на русском языке в соответствии с действующим
                                законодательством Республики Беларусь.</p>

                            <p>11.4. Ни одна из Сторон не вправе передавать свои права и обязанности по Договору
                                третьим лицам без предварительного письменного согласия другой Стороны. 11.5. Во всем
                                ином, что не предусмотрено Договором, Стороны руководствуются действующим
                                законодательством Республики Беларусь.</p>

                            <p>11.6. Неотъемлемой частью настоящего Договора является Приложение № 1 «Условия
                                приобретения лицензии на брендированное мобильное приложение».</p>
                        </div>
                        <div>
                            <p>12. Адреса и реквизиты сторон</p>

                            <p>12.1. Стороны безоговорочно соглашаются под адресом и реквизитами Сублицензиата
                                считать информацию, указанную им при оформлении на сайте Лицензиата.
                            </p>
                            <p>
                                12.2. Адрес и
                                реквизиты Лицензиата:
                            </p>
                            <p>
                                Индивидуальный предприниматель Дятлов К.В.
                                Республика Беларусь, Минская область, аг.Лесной, д.41, кв.120
                                УНП 692192486
                                Р/С: BY27ALFA30132B01360010270000
                                BIC: ALFABY2X в ЗАО «Альфа-Банк». г. Минск, ул. Сурганова, 43-47
                                Телефон: +375-44-7-937-937
                                www.quickresto.by
                                e-mail: info@quickresto.by</p>

                        </div>
                        <div>
                            <p>13. Приложения</p>
                            <p>13.1. Приложение №1.
                                <AdaptiveLink href="/licenseAgreement/annex/" useGatsbyLink> Специальные условия
                                    Лицензии на Опциональную
                                    программу - Брендированное мобильное приложение «White label».</AdaptiveLink></p>
                        </div>
                    </div>
                </section>

                <CtaForm
                    isFry={false}
                    className={pageStyles.pageSection}
                    isWhiteBackground
                />
            </DefaultLayout>
        )

    }

    return (
        <DefaultLayout
            title="Лицензионный договор на право использования системы автоматизации Quick Resto"
            metaTags={metaTags}
            mainWrapperClassName={classNames(
                pageStyles.pageWrapper,
                pageStyles.pageGray,
                styles.docs,
            )}
            linkCanonical="https://quickresto.ru/licenseAgreement/"
            footerClassName={pageStyles.pageSection}
        >
            <section
                className={classNames(styles.docs__container, pageStyles.pageSection)}
            >
                <div className={styles.docs__content}>
                    <h1 className={styles.bigMb}>Лицензионное соглашение</h1>

                    <div>
                        <p>
                            Лицензионный договор на право использования программы для ЭВМ
                            «Система автоматизации предприятий общественного питания «Quick
                            Resto»
                        </p>

                        <p>
                            Настоящий лицензионный договор (далее – «Договор», «Лицензионный договор»)
                            является офертой ООО «Квик Ресто» (ОГРН 5137746099046, ИНН 7726734798,
                            КПП 771401001, 125167 г. Москва, Ленинградский пр. 36, стр. 30, пом. 96),
                            именуемого в дальнейшем «Лицензиар», Пользователю, именуемому в дальнейшем
                            «Лицензиат» «Оператор персональных данных».
                        </p>
                    </div>

                    <div>
                        <p>1. Термины и определения</p>

                        <p>
                            1.1. Система автоматизации предприятий общественного питания «Quick Resto»
                            (далее – Программа, или Программа «Quick Resto») — результат интеллектуальной
                            деятельности —
                            программа для
                            ЭВМ «Система автоматизации предприятий общественного питания «Quick Resto» — ПО для
                            автоматизации предприятий общественного питания.
                        </p>

                        <p>
                            1.2. Прайс-лист — документ, отражающий ценовую политику Лицензиара (сведения о
                            тарифах/тарифных планах)
                            и содержащий сведения о функциональных возможностях Программных продуктов. Действующая
                            редакция документа опубликована
                            на сайте https://quickresto.ru/price/compare/.
                        </p>

                        <p>
                            1.3. Субъект персональных данных — физическое лицо, персональные данные которого
                            Лицензиат
                            обрабатывает с использованием Программы
                            / Опциональных программных продуктов Лицензиара.
                        </p>

                        <p>
                            1.4. Запрос — требования субъекта персональных данных, касающиеся обработки персональных
                            данных.
                        </p>

                        <p>
                            1.5. Конечный пользователь — физическое лицо, уполномоченное Лицензиатом на
                            использование
                            Программы / Опциональных программных продуктов Лицензиара.
                        </p>

                        <p>
                            1.6. Идентификация — процедура установления правомерности обращения Конечного
                            пользователя к
                            серверу Лицензиара.
                            Осуществляется на основании простой электронной подписи в виде логина и/или пароля и/или
                            иного кода доступа.
                            Порядок идентификации определяется выбранным Лицензиатом Тарифным планом.
                        </p>

                        <p>
                            1.7. Облачный бэк-офис («облако») — панель управления Системой автоматизации
                            предприятий общественного питания «Quick Resto», находящаяся и доступная на
                            выделенном для использования Лицензиатом домене http://адрес_бэк-офиса.quickresto.ru,
                            доступ к которому предоставляется Лицензиаром.
                        </p>

                        <p>
                            1.8. Лицензия – простая (неисключительная) лицензия, предоставляющая
                            Лицензиату неисключительные права использования Программы / Опциональных программ
                            на условиях настоящего Договора и выбранного Лицензиатом Тарифного плана, посредством
                            удаленного доступа
                            через информационно-телекоммуникационную сеть «Интернет».
                        </p>

                        <p>
                            1.9. Тарифный план – коммерческие условия предоставления Лицензии, в том числе
                            определяющие
                            срок действия Лицензии и размер лицензионного вознаграждения за право использования
                            Программы / Опциональных программных продуктов
                        </p>

                        <p>
                            1.10. Опциональные программные продукты (далее также - Опциональные программы) -
                            результаты
                            интеллектуальной
                            деятельности Лицензиара в виде отдельных дополнительных программ для ЭВМ, права на
                            использование которых Лицензиат
                            может приобрести за отдельную плату сроком на 1 год, и которые в части своего
                            функционала
                            способствуют в наибольшей
                            степени автоматизации деятельности предприятий общественного питания и их взаимодействию
                            с
                            Конечными пользователями.
                        </p>

                        <p>
                            Перечень Опциональных программ, право на использование которых может приобрести
                            Лицензиат у
                            Лицензиара
                            за дополнительную плату (вознаграждение) содержится в разделе 14 «Приложения» настоящего
                            Договора.
                        </p>

                        <p>1.11. Программные продукты – Программа «Quick Resto» и Опциональные программы.</p>
                    </div>

                    <div>
                        <p>2. Предмет лицензионного договора</p>

                        <p>2.1. Предметом настоящего Лицензионного договора является:</p>

                        <p>
                            а) передача Лицензиаром неисключительных прав использования результата интеллектуальной
                            деятельности — программы для ЭВМ «Система автоматизации предприятий общественного
                            питания
                            «Quick Resto» (Регистрационный № 2014661789) Лицензиату за вознаграждение на условиях
                            простой
                            (неисключительной) Лицензии путем предоставления доступа к «облаку» на сервере
                            Лицензиара;
                        </p>

                        <p>
                            б) передача Лицензиаром за дополнительное вознаграждение неисключительных прав
                            использования
                            результатов интеллектуальной деятельности – Опциональных программ или любой из таких
                            программ,
                            в зависимости от волеизъявления Лицензиата, на условиях простой (неисключительной)
                            Лицензии
                            путем
                            добавления такой (таких) опциональных программ к облаку Лицензиата на сервере
                            Лицензиара.
                        </p>

                        <p>
                            2.2. Программа является основным программным продуктом Лицензиара, без которого
                            использование Опциональных программ,
                            или любой (любых) из них будет функционально ограничено из-за особенностей облака п.1.7.
                            При
                            этом, приобретение
                            Лицензиатом прав на использование Опциональных программ, или любой (любых) из них
                            является
                            правом, а не обязанностью
                            Лицензиата, и осуществляется по его выбору в соответствии с Тарифными планами
                            Лицензиара.
                        </p>

                        <p>
                            2.3. Специальные условия приобретения прав на Опциональные программы содержатся в
                            соответствующих приложениях
                            (далее – Приложения) к настоящему Лицензионному договору.
                        </p>

                        <p>
                            Все условия настоящего Лицензионного договора распространяются как на саму Программу,
                            так и на Опциональные программы. При этом, если в отношении Опциональных программ
                            Приложения
                            предусматривают иные условия или термины, то приоритетную силу для таких Опциональных
                            программ
                            имеют соответствующие Опциональным программам Приложения.
                        </p>

                        <p>
                            2.4. Лицензия предоставляется только на использование тех Программных продуктов
                            Лицензиара
                            (Программы /Опциональных программ или любой (любых) из них), в части которых
                            Лицензионный
                            договор акцептован Лицензиатом.
                            Если иные условия Лицензионного договора позволяют трактовать права Лицензиата на
                            использование Программы / Опциональных
                            программ иначе, то следует руководствоваться условиями настоящего абзаца пункта 2.4.
                            Лицензионного договора.
                        </p>

                        <p>
                            Акцептом Лицензионного договора в части касающейся самой Программы является факт оплаты
                            лицензионного вознаграждения за
                            использование Программы согласно счету на оплату, выставленному Лицензиаром Лицензиату в
                            соответствии с Тарифным планом, выбранным Лицензиатом.
                        </p>

                        <p>
                            Акцептом Лицензионного договора в части касающейся какой-либо Опциональной программы
                            является факт оплаты лицензионного
                            вознаграждения за использование данной Опциональной программы, согласно счету на оплату,
                            выставленному Лицензиаром Лицензиату
                            в соответствии с Тарифным планом для этой Опциональной программы, выбранным Лицензиатом.
                        </p>

                        <p>
                            Специальные условия акцепта в отношении Опциональных программ могут содержаться в
                            Приложениях, относящихся
                            к данным Опциональным программам.
                        </p>

                        <p>
                            Лицензиат вправе акцептовать Лицензионный договор как одновременно в части Программы и
                            Опциональных
                            программ, так и только в части Программы, либо в части Опциональных программ/ любой из
                            Опциональных программ.
                        </p>

                        <p>
                            2.5. Описание Программы и Опциональных программ содержится на Интернет-сайте Лицензиара
                            (
                            <AdaptiveLink href="https://quickresto.ru"
                                          useGatsbyLink>https://quickresto.ru</AdaptiveLink>,
                            <AdaptiveLink href="/wl/" useGatsbyLink> https://quickresto.ru/wl/</AdaptiveLink>,
                            <AdaptiveLink href="/passkit/"
                                          useGatsbyLink> https://quickresto.ru/passkit/</AdaptiveLink>,
                            <AdaptiveLink href="/emenu/" useGatsbyLink> https://quickresto.ru/emenu/</AdaptiveLink>
                            ). Акцептуя настоящую оферту, Лицензиат подтверждает, что
                            ознакомлен в полном объеме с описанием и функциональными возможностями Программы и
                            опциональных программных продуктов, списком
                            оборудования необходимым для корректной работы Программы
                            (<AdaptiveLink href="/support/oborudovanie/spisok_podderzhivaemogo_oborudovaniya/"
                                           useGatsbyLink>https://quickresto.ru/support/oborudovanie/spisok_podderzhivaemogo_oborudovaniya/</AdaptiveLink>),
                            а также Лицензиат подтверждает что выбранные им Программные продукты соответствует его
                            требованиям
                            и ожиданиям от Программных продуктов.
                        </p>

                        <p>
                            2.6. Программные продукты предназначены исключительно для коммерческого использования и
                            не
                            могут
                            использоваться в целях, не связанных с предпринимательской деятельностью. Акцептуя
                            настоящую
                            оферту,
                            Лицензиат-физическое лицо подтверждает, что приобретает данные Программные продукты не
                            для
                            личного использования,
                            в связи с чем Закон Российской Федерации от 07.02.1992 № 2300-1 "О защите прав
                            потребителей"
                            не применим.
                        </p>

                        <p>2.7. Порядок оплаты лицензионного вознаграждения.</p>

                        <p>
                            2.7.1. Оплата по банковским реквизитам Лицензиара, указанным в счете на оплату,
                            признается
                            надлежащей,
                            если она осуществлена Лицензиатом в установленный в указанном счете срок с указанием в
                            платежном поручении
                            номера данного счета.
                        </p>

                        <p>В иных случаях применяются следующие правила:</p>

                        <p>
                            2.7.1.1. Оплата без указания в платежном поручении номера счета
                            (или с указанием неверного номера счета) не допускается и не считается надлежащим
                            акцептом, за исключением случаев, когда Лицензиар по своему усмотрению признает такую
                            оплату надлежащим акцептом. В этом случае денежные средства зачисляются по усмотрению
                            Лицензиара
                            в счет оплаты любого из ранее выставленных Лицензиату и еще неоплаченных счетов, срок
                            оплаты
                            по
                            которым не истек к моменту поступления платежа.
                        </p>

                        <p>
                            2.7.1.2. Оплата за Лицензиата от иных лиц принимается при условии, что в назначении
                            платежа
                            указаны номер счета на оплату и наименование Лицензиата, а также указано, что данный
                            платеж
                            осуществляется за этого Лицензиата. При несоблюдении лицом, осуществившем платеж за
                            Лицензиата
                            указанного условия, Лицензиар вправе возвратить данный платеж плательщику, в таком
                            случае
                            акцепт
                            не признается совершенным.
                        </p>

                        <p>
                            2.7.2. Оплата электронными средствами платежа (включая банковские карты) признается
                            надлежащей,
                            если осуществлена их законным владельцем (держателем). Использование таких средств
                            платежа
                            другими
                            лицами не допускается.
                        </p>
                    </div>

                    <div>
                        <p>3. Исключительные права</p>

                        <p>3.1. Исключительные права на Программу принадлежат Лицензиару на основании Договора об
                            отчуждении исключительного права на программу для ЭВМ от 05.10.2017 г., номер и дата
                            государственной
                            регистрации: РД0239300 от 12.12.2017 г., заключенного с SIA «Quick Resto».</p>

                        <p>Исключительные права на Опциональные программы принадлежат Лицензиару в силу факта их
                            создания Лицензиаром.</p>

                        <p>3.2. В Программных продуктах не используются никакие элементы, нарушающие права третьих
                            лиц.</p>

                        <p>3.3. Право использования Программных продуктов и право доступа к Облачному бэк-офису
                            предоставляется исключительно Лицензиату в объеме, оговоренном настоящим Лицензионным
                            договором.</p>

                        <p>При этом Стороны настоящего Лицензионного договора соглашаются, что Лицензиар вправе по
                            своему
                            усмотрению предоставить право использования Программных продуктов и право доступа к
                            Облачному
                            бэк-офису лицам, имеющим отношение к Лицензиату и/или осуществляемой им деятельности, по
                            их соответствующим письменным запросам Лицензиата. Лицензиат подтверждает, что в таких
                            случаях
                            не будет иметь каких-либо претензий, в том числе имущественного характера к
                            Лицензиару.</p>

                        <p>Предоставление Лицензиатом третьим лицам сублицензий на использование Программных
                            продуктов, или передача Лицензиатом третьим лицам иным образом прав на использование
                            Программных продуктов, <strong>не допускается</strong>, за исключением случаев, если
                            иное
                            предусмотрено
                            настоящим Договором (Приложениями к Договору), либо предварительно в письменном виде
                            будет
                            согласовано между Лицензиаром и Лицензиатом.</p>

                        <p>Несмотря на вышеизложенное в настоящем пункте Договора, Конечные пользователи вправе
                            использовать Программные продукты, только в пределах, необходимых для их взаимодействия
                            с Лицензиатом, и без права какой-либо передачи (предоставления) прав на указанное
                            использование
                            Программных продуктов третьим лицам.</p>
                    </div>

                    <div>
                        <p>4. Порядок предоставления доступа</p>

                        <p>4.1. Доступ к каждому Программному продукту Лицензиара, указанному в настоящем
                            Лицензионном
                            договоре,
                            предоставляется в течение 10 (десяти) календарных дней с момента поступления на счет
                            Лицензиара вознаграждения за право использования данного Программного продукта.</p>

                        <p>4.2. О предоставлении Лицензиаром Лицензиату доступа к Программному продукту
                            в отношении которого Лицензиатом был совершён акцепт (оплата лицензионного
                            вознаграждения согласно выбранному Тарифному плану), Лицензиар уведомляет
                            Лицензиата по его адресу электронной почты, указанному Лицензиатом при его регистрации
                            на сайте Лицензиара: <a href="https://quickresto.ru/">https://quickresto.ru/</a>,
                            указанном
                            в настоящему Договоре или
                            сообщенному
                            Лицензиатом Лицензиару иным образом.</p>

                        <p>Срок действия Лицензии на использование, выбранного Лицензиатом Программного продукта
                            для новых
                            пользователей начинает исчисляться с даты указанного уведомления Лицензиаром
                            Лицензиата о
                            предоставлении ему доступа к Программному продукту и истекает в момент окончания
                            срока действия
                            Тарифного плана, выбранного Лицензиатом в отношении данного Программного продукта
                            либо с даты,
                            указанной в счете на Программный продукт. Для действующих пользователей с даты,
                            указанной в счете на
                            Программный продукт.</p>

                        <p>Доступ к какому-либо Программному продукту действует в течение всего срока
                            действия Лицензии в отношении
                            данного Программного продукта.
                            При этом, если Лицензиат после предоставления ему доступа к Программным
                            продуктам не начал ими пользоваться,
                            то это обстоятельство никак не влияет на исчисление срока действия права
                            Лицензиата на использование Программных
                            продуктов, т.е. в таком случае данный срок не приостанавливается, не изменяется
                            и не сдвигается на новый период.</p>

                        <p>В исключительных случаях по согласованию Сторон настоящего Договора, либо по
                            усмотрению Лицензиара, начало
                            исчисления срока указанного доступа может быть изменено / срок предоставления
                            доступа может быть заморожен,
                            но только единожды, на срок не более шести месяцев. Данный пункт применим,
                            только в случае приобретения Лицензиатом
                            годовой подписки на Программу. За неиспользование Программных продуктов в период
                            заморозки по любым причинам,
                            не зависящим от Лицензиара, Лицензиар не несет ответственности.</p>

                        <p>4.3. Доступ к Программным продуктам автоматически пролонгируется на оплаченный
                            период, если до
                            момента истечения срока действия права Лицензиата на использование Программных
                            продуктов, Лицензиат
                            осуществит оплату Лицензиару лицензионного вознаграждения за право использования
                            Программных продуктов
                            в течение нового срока, согласно выбранного Лицензиатом Тарифного плана. При
                            этом, количество таких
                            пролонгаций не ограничено, на каждый новый оплаченный период предоставляется
                            новая Лицензия на Программные
                            продукты на срок согласно выбранному и оплаченному Тарифному плану.</p>

                        <p>4.4. По окончании срока действия одного Тарифного плана Лицензиат по своему
                            усмотрению
                            вправе перейти на другой Тарифный план, однако в течение срока действия
                            оплаченного Тарифного
                            плана переход на иной Тарифный план допускается только в сторону повышения
                            тарифного плана,
                            понижение тарифного плана не допускается.</p>

                        <p>4.5. По итогам каждого периода использования прав на Программные продукты
                            Лицензиар направляет
                            на электронную почту, указанную Лицензиатом, акт исполнения обязательств по
                            настоящему Договору.
                            При отсутствии у Лицензиата в течение 3 (трех) календарных дней с момента
                            направления ему данного
                            акта мотивированных возражений данный акт считается согласованным и подписанным
                            Лицензиатом.</p>

                    </div>

                    <div>
                        <p>5. Условия использования</p>

                        <p>5.1. Лицензиат может использовать Программные продукты следующими способами:</p>

                        <p>5.1.1. круглосуточно получать доступ к серверу, за исключением времени проведения
                            профилактических работ, и воспроизводить графическую часть (рабочий интерфейс)
                            на экране персонального компьютера, мобильного устройства;</p>

                        <p>5.1.2. использовать все функциональные возможности Программных продуктов, описанные
                            Тарифным планом в прайс-листе Лицензиара;</p>

                        <p>5.1.3. размножать документацию для личного пользования.</p>

                        <p>5.2. Если иное не предусмотрено настоящим Договором, возможность
                            использовать Программные продукты для подготовки, хранения и передачи
                            данных предоставляется только Лицензиату.</p>
                    </div>

                    <div>
                        <p>6.1. Обязанности Лицензиара:</p>

                        <p>6.1.1. обеспечение выполнения Программными продуктами функций, описанных в приложении
                            к прайс-листу «Перечень функциональных возможностей» <a
                                href="https://quickresto.ru/price/">https://quickresto.ru/price/</a>;</p>

                        <p>6.1.2. своевременное обновление программного обеспечения на сервере;</p>

                        <p>6.1.3. обеспечение круглосуточной доступности сервера за исключением времени проведения
                            профилактических работ;</p>

                        <p>6.1.4. хранение данных Лицензиата до момента получения уведомления Лицензиата о
                            необходимости их уничтожения на сервере;</p>

                        <p>6.1.5. обеспечение конфиденциальности данных, размещенных Лицензиатом в Программных
                            продуктах, на весь период их
                            нахождения на сервере Лицензиара.</p>

                        <p>6.2. Права Лицензиара:</p>

                        <p>6.2.1. модификация или выпуск новых версий Программных продуктов в любое время и по
                            любой причине, в том числе в целях удовлетворения потребностей Лицензиата или требований
                            конкурентоспособности, в целях соблюдения действующего законодательства Российской
                            Федерации.
                            Лицензиар оставляет за собой право добавлять новые свойства и функциональные возможности
                            Программных продуктов или удалять из них уже существующие свойства и функциональные
                            возможности;</p>

                        <p>6.2.2. блокирование доступа к Программным продуктам при нарушении Лицензиатом условий
                            настоящего
                            Лицензионного договора.</p>

                        <p>6.2.3. в любое время без предварительного уведомления Лицензиата в одностороннем порядке
                            ограничивать, расширять, дополнять, модифицировать и иным образом изменять Сайт,
                            Программные
                            продукты, Мобильное приложение, любые их элементы и части. Совершая Акцепт, Лицензиат
                            понимает
                            и признает, что указанные действия являются неотъемлемой частью процесса создания и
                            функционирования
                            Сайта, Программных продуктов, Мобильного приложения, а также дает согласие на их
                            совершение Лицензиару
                            по его усмотрению без предварительного уведомления Лицензиата.</p>

                        <p>6.2.4. самостоятельно, по своему желанию и выбору предоставлять
                            персональные или акционные скидки.</p>

                        <p>6.2.5. проводить профилактические работы на сервере, включая работы,
                            требующие приостановки доступа в Программу.</p>

                        <p>6.3. Обязанности Лицензиата:</p>

                        <p>6.3.1. отказ от попыток копировать, модифицировать, декомпилировать,
                            деассемблировать Программные продукты;</p>

                        <p>6.3.2. отказ от попыток доступа к информации третьих лиц,
                            хранящейся в Программных продуктах, за исключением случаев
                            обработки персональных данных, осуществляемой Лицензиатом в
                            соответствии с настоящим Договором;</p>

                        <p>6.3.3. своевременное направление уведомлений Лицензиару о
                            необходимости уничтожения данных на сервере;</p>

                        <p>6.3.4. соблюдение Правил информационной безопасности на рабочем месте.</p>

                        <p>6.3.5. предоставление Лицензиару всех сведений и документов,
                            необходимых для выполнения Лицензиаром своих обязательств по
                            настоящему Лицензионному договору;</p>

                        <p>6.3.6. обеспечение конфиденциальности кодов аутентификации, при их наличии;</p>

                        <p>6.3.7. использовать актуальную версию Программных продуктов и оборудования
                            и обновлять до последней версии, предоставленной лицензиаром</p>

                        <p>6.4. Права Лицензиата:</p>

                        <p>6.4.1. получение круглосуточного доступа к серверу за исключением
                            времени проведения профилактических работ;</p>

                        <p>6.4.2. внесение предложений по изменению функциональных возможностей Программных
                            продуктов;</p>

                        <p>6.4.3. выбор Тарифного плана.</p>

                        <p>6.4.4. по истечении Тестового периода или во время Тестового периода уплатить
                            вознаграждение в соответствии с Тарифами либо отказаться от уплаты вознаграждения и
                            использования Программы;</p>

                        <p>6.4.5. по истечении Срока действия лицензии уплатить вознаграждение в соответствии с
                            Тарифами для
                            получения права использования Программных продуктов, Мобильного приложения на новый срок
                            либо
                            отказаться от уплаты вознаграждения и использования Программных продуктов.</p>
                    </div>

                    <div>
                        <p>
                            7. Обязательства Сторон в области обработки персональных данных
                        </p>

                        <p>7.1. Лицензиат гарантирует:</p>

                        <p>7.1.1. что при обработке персональных данных им соблюдены
                            все права субъектов персональных данных, предусмотренные действующим законодательством
                            Российской Федерации в области защиты персональных данных;</p>

                        <p>7.1.2. что им получено согласие субъектов персональных данных на обработку принадлежащих
                            им персональных данных с использованием Программных продуктов;</p>

                        <p>7.1.3. что при размещении персональных данных им соблюдены все принципы и условия
                            обработки персональных данных и ограничения, предусмотренные действующим
                            законодательством Российской Федерации;</p>

                        <p>7.1.4. что в случае прекращения действия настоящего Лицензионного договора им в течение
                            10
                            (десяти)
                            рабочих дней будут уничтожены персональные данные, размещенные в Программных продуктах,
                            самостоятельно,
                            либо направлено своевременное уведомление Лицензиару о необходимости такого
                            удаления.</p>

                        <p>7.2. В целях соблюдения прав субъектов персональных данных, являющихся работниками
                            Лицензиата
                            или лицами, доступ к персональным данным которых имеется у Лицензиата в связи с
                            исполнением
                            заключенных с такими лицами гражданско-правовых договоров, Стороны договорились
                            установить
                            следующий порядок взаимодействия:</p>

                        <p>7.2.1. Лицензиар не имеет доступа к персональным данным лиц, указанных в пункте 7.2
                            настоящего Договора.
                            Все операции с персональными данными таких лиц осуществляются Лицензиатом при наличии к
                            тому
                            предусмотренных
                            законом оснований.</p>

                        <p>7.2.2. По требованию Лицензиара Лицензиат обязан предоставить доказательства соблюдения
                            прав
                            субъекта персональных данных, предусмотренных действующим законодательством Российской
                            Федерации,
                            а также документы, подтверждающие надлежащее исполнение Лицензиатом иных обязательств,
                            предусмотренных
                            действующим законодательством в области обработки персональных данных.</p>

                        <p>7.2.3. В случае проведения проверки деятельности Лицензиара и/или выявления нарушений
                            обработки
                            персональных данных уполномоченным органом по защите прав субъектов персональных данных
                            Лицензиар
                            адресует требование уполномоченного органа, которое не может быть выполнено Лицензиаром
                            в
                            силу
                            объективных причин, Лицензиату. Указанное требование подлежит немедленному исполнению
                            Лицензиатом.</p>

                        <p>7.2.4. С момента передачи Лицензиаром требований уполномоченного органа по защите прав
                            субъектов
                            персональных данных Лицензиат становится ответственным за неисполнение или ненадлежащее
                            исполнение
                            указанных требований в соответствующей части и обязуется возместить Лицензиару
                            причиненные
                            таким
                            неисполнением убытки в течение 20 календарных дней с момента получения требования
                            Лицензиара
                            в
                            письменной форме. Данное положение не может истолковываться как освобождающее Лицензиата
                            от
                            ответственности за совершение операций с персональными данными лиц, указанных в пункте
                            7.2
                            настоящего Договора.</p>

                        <p>7.3. Лицензиар гарантирует:</p>

                        <p>7.3.1. что им приняты необходимые организационные и технические
                            меры для защиты персональных данных от неправомерного или случайного
                            доступа к ним, уничтожения, изменения, блокирования, копирования, распространения
                            персональных
                            данных, а также от иных неправомерных действий в отношении персональных данных, в
                            частности:</p>

                        <p>· определение угроз безопасности персональных данных при их обработке;</p>

                        <p>· установление правил доступа к обрабатываемым персональным данным;</p>

                        <p>· обнаружение фактов несанкционированного доступа к персональным данным и принятие мер по
                            их
                            пресечению;</p>

                        <p>· проведение оценки эффективности принимаемых мер по обеспечению безопасности
                            персональных
                            данных и контроля за принимаемыми мерами.</p>

                        <p>7.3.2. что при передаче данных по телекоммуникационным каналам связи им применяются
                            средства
                            криптографической защиты информации.</p>

                        <p>7.4. Акцептуя настоящую оферту, Лицензиат-физическое лицо дает согласие на передачу своих
                            персональных
                            данных Лицензиару и (или) третьим лицам и их обработку Лицензиаром и (или) третьими
                            лицами.</p>

                    </div>

                    <div>
                        <p>8. Территория действия</p>

                        <p>
                            8.1. Настоящий договор действует на всей территории Российской
                            Федерации.
                        </p>
                    </div>

                    <div>
                        <p>
                            9. Срок действия. Внесение изменений в условия настоящего
                            договора
                        </p>

                        <p>9.1. Настоящий Договор в отношении каждого Программного продукта вступает в силу
                            (признается
                            заключенным)
                            с момента получения Лицензиаром акцепта Лицензиата (принятия Лицензиатом) условий
                            настоящего
                            Лицензионного
                            договора в части данного Программного продукта и действует в отношении этого
                            Программного
                            продукта до момента
                            окончания срока доступа к указанному Программному продукту (Лицензии на право
                            использования
                            указанного Программного продукта).</p>

                        <p>Сроки указанного доступа (Лицензии) определяются в соответствии с п.4.2. настоящего
                            Лицензионного договора,
                            а момент акцепта определяется согласно п.2.4. Лицензионного договора. В соответствующих
                            Приложениях к настоящему
                            Договору могут быть установлены иные специальные условия в отношении Опциональных
                            программ в
                            части: срока Лицензии,
                            срока доступа к Опциональным программам, а также момента акцепта.</p>

                        <p>Акцепт означает безоговорочное принятие Лицензиатом всех условий Лицензионного договора в
                            отношении
                            Программного продукта, за право использования которого Лицензиатом произведена
                            соответствующая оплата
                            Лицензиару лицензионного вознаграждения.</p>

                        <p>Каждый факт оплаты признается отдельным акцептом и приводит к совершению самостоятельной
                            сделки,
                            за исключением случаев оплаты одного и того же Программного продукта за один и тот же
                            период
                            несколькими платежами (оплата Программного продукта по частям), если такие платежи
                            совершены
                            от
                            имени одного лица.</p>

                        <p>По окончании срока действия Лицензионного договора в отношении какого-либо Программного
                            продукта,
                            Договор автоматически пролонгируется на новый срок на условиях вновь выбранного
                            Лицензиатом
                            Тарифного плана, в соответствии с которым произведена оплата.</p>

                        <p>9.2. Лицензиар имеет право на одностороннее внесение изменений в условия настоящего
                            Договора путем публикации таких изменений сайте https://quickresto.ru/licenseAgreement/.
                            Внесение изменений в оферту влечет за собой внесение этих изменений в заключенный и
                            действующий
                            между Лицензиаром и Лицензиатом Договор, и эти изменения в Договор вступают в силу
                            одновременно
                            с такими изменениями в оферту.</p>

                        <p>9.3. В случае нарушения Лицензиатом условий настоящего Договора Лицензиар вправе в
                            одностороннем
                            внесудебном порядке досрочно расторгнуть Договор (отказаться от исполнения Договора) и
                            незамедлительно
                            блокировать доступ к серверу без предварительного уведомления Лицензиата.</p>

                    </div>

                    <div>
                        <p>10. Вознаграждение</p>

                        <p>10.1. Лицензиат оплачивает Лицензиару лицензионное вознаграждение за право использования
                            Программными продуктами в соответствии с выбранными им Тарифными планами, в размере,
                            установленном
                            в выставленных ему счетах на оплату.</p>

                        <p>10.2. Лицензиат оплачивает выставленный Лицензиаром счет путем перечисления 100% суммы,
                            указанной в счете. Счет может выставляться путем размещения соответствующей информации
                            на
                            Интернет-сайте Лицензиара в Личном кабинете Лицензиата (http://www.quickresto.ru).</p>

                        <p>10.2.1. Лицензиат оплачивает выставленный Лицензиаром счет путем перечисления - 100%
                            суммы,
                            указанной в счете в течение 5 (пяти) рабочих дней с даты получения данного счета.</p>

                        <p>10.2.2. Лицензиат оплачивает выставленный Лицензиаром счет путем перечисления предоплаты
                            - 100% суммы, указанной в счете до 00.00 часов первого дня начала очередного периода
                            предоставления
                            неисключительных прав на Программный продукт, указанный в счете.</p>

                        <p>10.2.3. В случае непоступления средств на расчетный счет Лицензиара до 00.00 часов дня
                            начала
                            нового периода предоставления неисключительных прав на Программу, указанного в счете,
                            Лицензиар
                            оставляет за собой право заблокировать доступ к облачному бэк-офису («облаку»)
                            Лицензиата.
                            При этом Лицензиар не несет ответственность перед Лицензиатом за специальные или
                            косвенные
                            убытки,
                            связанные с блокировкой доступа к облачному бэк-офису («облаку») Лицензиата по причине
                            несвоевременной
                            оплаты Лицензиару лицензионного вознаграждения за право использования Программы в том
                            числе
                            и в случае,
                            если Лицензиар был предупрежден о возможности появления таких убытков в следствие
                            блокировки
                            доступа
                            облачному бэк-офису («облаку»).</p>

                        <p>10.3. В случае, если в течение 5 (пяти) дней с момента получения оплаченного доступа к
                            Программному
                            продукту Лицензиар не получил претензий Лицензиата, связанных с объемом предоставленных
                            прав,
                            то неисключительное право использования данным Программным продуктом считается
                            предоставленным
                            Лицензиату в полном объеме надлежащим образом.</p>

                        <p>10.4. Лицензиат не вправе в одностороннем порядке уменьшить ранее выбранный им период
                            использования
                            Программных продуктов и определяемый в соответствии с этим периодом размер
                            вознаграждения
                            Лицензиара.
                            В этой связи в случае, если по причинам, зависящим от Лицензиата, длительность
                            использования
                            какого-либо
                            Программного продукта Лицензиатом фактически оказалась меньше, чем срок, на который
                            Лицензиат изначально
                            приобрел право пользования Программными продуктами (каким-либо Программным продуктом),
                            размер вознаграждения,
                            определяемый в соответствии с настоящим разделом Договора, уменьшению/возврату не
                            подлежит.</p>

                        <p>10.5. К причинам независимым от Лицензиара указанным в пункте 10.4 относятся любые
                            обстоятельства,
                            на которые Лицензиар не может повлиять и которые никак не связаны с действиями самого
                            Лицензиара,
                            в том числе проблемы Лицензиата с арендой помещений, интернет-соединение, проблемы с
                            Банком,
                            проблемы
                            с электроэнергией, закрытие заведения, срыв открытия заведения и иные обстоятельства и
                            иные
                            непоименованные
                            события, не зависящие от Лицензиара и на которые Лицензиар не может повлиять.</p>
                    </div>

                    <div>
                        <p>11. Ответственность</p>

                        <p>11.1. Стороны настоящего Договора несут ответственность в соответствии с
                            законодательством
                            Российской Федерации.</p>

                        <p>11.2. Лицензиар не несет ответственности за прямые или косвенные убытки, включая
                            упущенную
                            выгоду,
                            возникшие в результате применения Программных продуктов Лицензиатом и/или Конечными
                            пользователями, а
                            также иными лицами, правомерно использующими Программные продукты, а также из-за
                            возможных
                            ошибок, сбоев
                            и недоступности Сайта, Программных продуктов, Мобильного приложения; Лицензиар ни при
                            каких
                            обстоятельствах
                            не несет перед Лицензиатом ответственности за ущерб, вынужденные перерывы в деловой
                            активности, потерю деловых
                            либо иных данных или информации, претензии или расходы, косвенные или случайные убытки,
                            а
                            также упущенную выгоду
                            и утерянные сбережения, вызванные использованием или связанные с использованием
                            Программных
                            продуктов,
                            а также за ущерб, вызванный возможными ошибками и опечатками Программы.</p>

                        <p>11.3. Лицензиар не несет ответственности за невозможность использования Программных
                            продуктов
                            по
                            причинам, не зависящим от Лицензиара.</p>

                        <p>11.4. Лицензиар не несет ответственности за обеспечение достоверности,
                            полноты, точности и актуальности персональных данных, размещенных Лицензиатом.
                            Все полученные от Лицензиата персональные данные обрабатываются в том виде, как они
                            были получены.</p>

                        <p>11.5. Лицензиар не несет ответственности за несоблюдение Лицензиатом организационных и
                            иных
                            мер,
                            приведшее к неправомерному или случайному доступу к персональным данным лиц, не
                            уполномоченных
                            Лицензиатом на обработку персональных данных, а также повлекшее их уничтожение,
                            изменение,
                            блокирование, копирование или распространение, а также иные неправомерные действия
                            со стороны работников Лицензиата и/или третьих лиц.</p>

                        <p>11.6. В случае неисполнения Лицензиатом обязанности уничтожить персональные данные,
                            размещенные в Программных продуктах, в течение 10 рабочих дней с момента прекращения
                            действия настоящего Договора в отношении этих Программных продуктов, Лицензиар вправе
                            уничтожить персональные данные.</p>

                        <p>11.7. Лицензиар не может гарантировать работоспособность Программных продуктов и не несет
                            за это ответственность в случае, если у Лицензиата отсутствует последняя версия
                            (своевременное обновление)
                            необходимого программного обеспечения.</p>

                        <p>11.8. Лицензиар не может гарантировать работоспособность Программных продуктов и не несет
                            за
                            это
                            ответственность, если Лицензиат в работе с Программными продуктами не использует
                            рекомендуемое Лицензиаром оборудование,
                            список которого содержится на интернет-сайте Лицензиара по адресу:
                            (https://quickresto.ru/support/oborudovanie/spisok_podderzhivaemogo_oborudovaniya/).
                            Лицензиар не несет ответственности за сбои в работе Программных продуктов в случае,
                            если Программные продукты установлены на оборудовании и/или совместно с оборудованием не
                            рекомендуемым Лицензиаром.</p>

                        <p>11.9. Ответственность сторон за нарушение обязательств по настоящему Договору
                            определяется
                            также и иными положениями настоящего Договора, а также действующим законодательством
                            Российской Федерации.</p>

                        <p>11.10. Согласно пункту 40 постановления Пленума Верховного Суда РФ от 23 апреля 2019 г. N
                            10
                            "О применении
                            части четвертой Гражданского кодекса Российской Федерации" разъяснено, что по смыслу
                            пункта
                            5 статьи 1235
                            ГК РФ в его взаимосвязи с пунктом 4 статьи 1237 ГК РФ вознаграждение по возмездному
                            лицензионному
                            договору уплачивается за предоставление права использования результата интеллектуальной
                            деятельности
                            или средства индивидуализации. В связи с этим лицензиару не может быть отказано в
                            удовлетворении
                            требования о взыскании вознаграждения по мотиву неиспользования лицензиатом
                            соответствующего
                            результата или средства. Если сторонами согласована плата за предоставление права
                            использования
                            результата интеллектуальной деятельности или средства индивидуализации в твердой сумме,
                            а
                            также
                            дополнительно согласован размер вознаграждения в форме процентных отчислений от дохода
                            (выручки)
                            (абзац третий пункта 5 статьи 1235 ГК РФ), при неиспользовании результата
                            интеллектуальной
                            деятельности
                            или средства индивидуализации лицензиатом уплате подлежит только сумма, согласованная в
                            твердом размере.
                            При этом лицензиар не лишен права потребовать возмещения убытков, вызванных
                            неиспользованием
                            результата
                            интеллектуальной деятельности или средства индивидуализации, и расторгнуть договор.</p>

                        <p>11.11. Лицензиар не гарантирует, что Сайт, Программные продукты, Мобильные приложения
                            будут
                            доступны для
                            использования Лицензиатом круглосуточно, в определенный момент времени или в течение
                            определенного периода времени,
                            однако стремится обеспечить такой режим работы Сайта, Программных продуктов, Мобильных
                            приложений.</p>

                        <p>11.12. Лицензиар предпримет все усилия для устранения каких-либо сбоев и ошибок, в случае
                            их
                            возникновения,
                            в максимально короткие сроки. При этом Лицензиар не гарантирует отсутствия ошибок и
                            сбоев
                            при
                            оказании Заказчику Услуг, в том числе в отношении работы программного обеспечения.</p>
                    </div>

                    <div>
                        <p>12. Прочие условия</p>

                        <p>12.1. Принимая условия настоящего Договора, Лицензиат дает согласие на получение
                            дополнительной
                            информации и информационных рассылок по указанному при регистрации адресу и
                            телефону.</p>

                        <p>12.2. Принимая условия настоящего Договора, Лицензиат подтверждает наличие у него
                            законных
                            оснований для обработки с использованием Программных продуктов принадлежащей ему
                            информации,
                            в том числе персональных данных.</p>

                        <p>12.3. В случае, если у Лицензиата с третьим лицом заключен какой-либо гражданско-правовой
                            договор
                            (договоры), в том числе договор коммерческой концессии (договор франчайзинга),
                            предполагающий передачу
                            Лицензиату таким третьим лицом прав на использование средств индивидуализации товаров,
                            работ
                            и услуг,
                            Лицензиат соглашается, что такое третье лицо – при условии заключения между этим третьим
                            лицом и Лицензиаром
                            соответствующего лицензионного или иного договора:</p>

                        <p>- будет иметь доступ к информации, содержащейся в облачном бэк-офисе («облаке»)
                            Лицензиата.
                            В силу изложенного и с учетом того, что Лицензиар не будет располагать доступом к такого
                            рода
                            сведениям, ответственность за любые последствия, связанные с наличием у таких третьих
                            лиц
                            доступа
                            к названной информации, лежит исключительно на Лицензиате;</p>

                        <p>- может обратиться к Лицензиару с письменной просьбой об ограничении возможности
                            редактирования
                            определенных модулей Программных продуктов в бэк-офисе Лицензиата, имеющим отношение
                            к переданным ему указанным третьим лицом прав на использование средств индивидуализации
                            товаров, работ и услуг. При этом, если такое право предусмотрено в договоре между
                            Лицензиатом
                            и третьим лицом, Лицензиар вправе удовлетворить указанную просьбу третьего лица об
                            ограничении
                            возможностей Программных продуктов.</p>

                        <p>Лицензиат также подтверждает, что в случае наступления (возникновения) событий,
                            предусмотренных
                            настоящим пунктом 12.3. Лицензионного договора, такие события не являются (не будут
                            являться)
                            каким-либо нарушением его права пользования Программными продуктами, или нарушением
                            каких-либо
                            иных прав Лицензиата и, соответственно, в таких случаях вознаграждение Лицензиара
                            изменению
                            не
                            подлежит. Кроме того, при наступлении (возникновении) вышеуказанных событий, Лицензиар
                            освобождается
                            от какой-либо ответственности (от обязанности возместить Лицензиату какие-либо убытки),
                            в
                            том числе в
                            случаях, когда вышеуказанным третьим лицом Лицензиару предоставлены недостоверные
                            информация
                            и/или документы.</p>

                        <p>12.4. Договор, его заключение и исполнение регулируется действующим законодательством
                            Российской Федерации.
                            Все вопросы, не урегулированные или урегулированные не полностью офертой, регулируются в
                            соответствии
                            с материальным правом Российской Федерации. Споры, возникающие из настоящего Договора,
                            разрешаются в
                            Арбитражном суде Московской области, а в случае, если спор относится к
                            подведомственности
                            суда
                            общей юрисдикции, – в Симоновском районном суде г. Москвы.</p>

                        <p>12.5. Лицензиат подтверждает, что:</p>

                        <p>- Перед заключением настоящего Договора в полном объеме ознакомлен с
                            функционалом (возможностями) Программных продуктов, в том числе путем
                            тестирования Программы, получения консультаций Лицензиара по использованию
                            Программных продуктов (по работе с Программными продуктами) и по их установке
                            и ознакомлен со всей информацией содержащейся в счете;</p>

                        <p>-Программа является универсальным программным продуктом и предоставляется
                            Лицензиату в том виде «как есть» («AS IS») в соответствии с общепринятым в
                            международной практике принципом. Это означает, что за проблемы, возникающие в
                            процессе установки (если применимо), обновления, поддержки и эксплуатации Сайта,
                            Программных продуктов, Мобильных приложений и связанные с совместимостью с другим
                            программным обеспечением (пакетами, драйверами, браузером и др.) или связанные с
                            проблемами, возникающими из-за неоднозначного толкования сопроводительной документации
                            (при ее наличии) или несоответствия результатов использования Сайта, Программных
                            продуктов,
                            Мобильных приложений ожиданиям Лицензиата, Лицензиар ответственности не несет.</p>

                        <p>- осознает, что при неуплате продления Лицензии на опциональные программы, Лицензиар
                            вправе удалить или скрыть до 3-х месяцев, а затем удалить, опциональные программы
                            Лицензиата и отключить функционал настройки в облачном бэк-офисе Лицензиата;</p>

                        <p>- осознает, что при неуплате продления Лицензии на Программу, Лицензиар вправе
                            приостановить работу на неопределенный срок по усмотрению Лицензиара до получения
                            оплаты от Лицензиата, а затем Лицензиар вправе полностью отключить функционал в
                            облачном бэк-офисе Лицензиата, при этом Лицензиар не несет ответственность перед
                            Лицензиатом за специальные или косвенные убытки, связанные с блокировкой доступа
                            к облачному бэк-офису («облаку») Лицензиата по причине несвоевременной оплаты
                            Лицензиару лицензионного вознаграждения за право использования Программы в том числе
                            и в случае, если Лицензиар был предупрежден о возможности появления таких убытков в
                            следствие блокировки доступа облачному бэк-офису («облаку»).;</p>

                        <p>- Лицензиар оставляет за собой право приостанавливать работу сайта Программы
                            для проведения профилактических работ</p>

                        <p>- Заключает настоящий Договор, так как убедился в том, что Программные
                            продукты в полной мере соответствуют целям, потребностям и ожиданиям Лицензиата.</p>

                        <p>- Программа соответствует его требованиям на момент акцепта и будет соответствовать
                            им впоследствии</p>

                        <p>- Программные продукты Quick Resto не влияют на работу локальной сети
                            заведения, не влияют на скорость передачи данных между устройствами по кабелю
                            ethernet или wi-fi, не влияют на работу кассового оборудования и не влияют на
                            скорость печати чеков. Все проблемы характера работы локальной или интернет-сети,
                            относятся к проблемам провайдера, администратора или самого клиента, который
                            обслуживает работу его локальной сети заведения.</p>

                        <p>- Стабильность взаимодействия между терминалом и внешним оборудованием
                            обеспечивается множеством дополнительных факторов: расположение роутера и
                            терминала и устройства, наличие конфликтующих сетей, и то, насколько «загружен»
                            канал.</p>

                        <p>-Лицензиар не несет ответственности за сетевое подключение, стабильность
                            сетевого взаимодействия между устройствами и работу устройств Лицензиата</p>

                        <p>-Приобретая Опциональные программы без приобретения основной программы п.1.1
                            настоящего Договора – Лицензиат понимает, что основная программа будет предоставлена
                            не в полном функционале в связи с особенностями Облака п.1.7 настоящего Договора</p>

                        <p>-Подтверждает, что намеревается пользоваться Программными продуктами только
                            в предпринимательских целях (своих или в интересах третьего лица –
                            коммерческой организации или индивидуального предпринимателя). Лицензиат
                            не является потребителем в смысле Закона РФ № 2300-1 от 07.02.1992 г. «О
                            защите прав потребителей».</p>

                        <p>12.6. Программные продукты не могут влиять на канальный/физический
                            уровень взаимодействия (осуществляется Лицензиатом «на месте») и на межсетевой
                            уровень взаимодействия (осуществляется роутером и операционной системой).</p>

                        <p>12.7. Требования Лицензиара к организации работы сети и устройств в сети Лицензиата.</p>

                        <p>1) Оборудование, взаимодействующее с кассовым терминалом (фискальный регистратор,
                            банковский терминал, весы, планшет повара и т.д.) должны находиться в отдельной сети.
                            К этой рабочей сети не должны подключаться видеокамеры и частные
                            устройства сотрудников и гостей заведения.</p>

                        <p>2) Для устройств в рабочей сети должны быть заданы внутренние статические ip-адреса</p>

                        <p>3) Уровень WiFi сигнала должен принимать значение RSSI от -35 до -65 дБм.
                            Если значение находится в диапазоне от -65 до -120 дБм, то это не обеспечит
                            стабильную работу оборудования в локальной сети заведения.</p>

                        <p>4) Среднее значение задержки (ping) не должно превышать 100 миллисекунд
                            (мс) при использовании протокола TCP и 50 мс при использовании протокола UDP.</p>

                        <p>5) Допустимый процент потерянных пакетов зависит от конкретных условий сети и
                            требований к качеству передачи данных. В общем случае, при использовании
                            протокола TCP, допустимый процент потерянных пакетов должен быть менее 1%,
                            а при использовании
                            протокола UDP, допустимый процент может быть выше, но обычно не должен превышать
                            5%.</p>

                        <p>6) При подключении по LAN-кабелю (класс LAN-кабеля не должен быть ниже 5E)
                            необходимо надежное подключение LAN-кабелей - они должны быть надежно обжаты
                            и зафиксированы и не подвержены электромагнитным, механическим и иным
                            воздействиям.</p>

                    </div>

                    <div>
                        <p>
                            13. Специальные условия на лицензию на программное обеспечение
                            «Брендированное мобильное приложение»
                        </p>

                        <p>13.1. За отдельное дополнительное вознаграждение Лицензиат по своему выбору может
                            приобрести
                            неисключительные
                            права использования результатов интеллектуальной деятельности – следующих программ для
                            ЭВМ:</p>

                        <p>«Брендированное мобильное приложение «White label», которое Лицензиар в соответствии с т
                            ребованиями Лицензиата адаптирует под его деятельность и которое предназначается для
                            использования клиентами Лицензиата (потребителями товаров, работ, услуг Лицензиата).</p>

                        <p>Краткое описание программы для ЭВМ «Брендированное мобильное приложение «White label» и
                            её
                            возможностей,
                            а также преимуществ содержится по следующей интернет ссылке: <AdaptiveLink href="/wl/"
                                                                                                       useGatsbyLink> https://quickresto.ru/wl/</AdaptiveLink>.
                        </p>

                        <p>«Брендированный клиентский сайт», который позволяет формировать (наполнять содержимым) и
                            редактировать сайт редактировать сайт Лицензиата, как предприятия или сети предприятий
                            общественного питания, в сети интернет.</p>

                        <p>Краткое описание программы для ЭВМ - «Брендированный клиентский сайт» и её
                            возможностей, а также преимуществ содержится по следующей интернет ссылке:
                            <AdaptiveLink href="/emenu/"
                                          useGatsbyLink> https://quickresto.ru/emenu/ </AdaptiveLink> и
                            <AdaptiveLink href="/wl/" useGatsbyLink> https://quickresto.ru/wl/</AdaptiveLink>.</p>

                        <p>Сервис управления электронными картами «Электронная карта лояльности»,
                            которое позволяет формировать для клиентов Лицензиата как предприятия или
                            сети предприятий общественного питания электронных карт лояльности.</p>

                        <p>Краткое описание программы для ЭВМ – сервис управления электронными картами
                            «Электронная карта лояльности» и её возможностей, а также преимуществ содержится
                            по следующей интернет ссылке: <AdaptiveLink href="/passkit/"
                                                                        useGatsbyLink> https://quickresto.ru/passkit/</AdaptiveLink>.
                            13.2. Приобретение прав на любую из вышеперечисленных Опциональных программ является
                            правом,
                            а не обязанностью Лицензиата.</p>

                        <p>13.3. Специальные условия Лицензии на вышеперечисленные Опциональные программы
                            содержатся в Приложениях № 1-3 к настоящему Лицензионному договору. На указанные
                            Приложения
                            распространяются все условия настоящего Лицензионного договора в части, не
                            противоречащей
                            этим Приложениям.</p>
                    </div>

                    <div>
                        <p>14. Приложения</p>

                        <p>14.1. Приложение №1.
                            <AdaptiveLink href="/licenseAgreement/annex/" useGatsbyLink> Специальные условия
                                Лицензии на Опциональную
                                программу - Брендированное мобильное приложение «White label».</AdaptiveLink></p>

                        <p>14.2.Приложение № 2.
                            <AdaptiveLink href="/licenseAgreement/annex2/" useGatsbyLink> Специальные условия
                                Лицензии на Опциональную
                                программу - «Брендированный клиентский сайт».</AdaptiveLink></p>

                        <p>14.3.
                            Приложение № 3.
                            <AdaptiveLink href="/licenseAgreement/annex3/" useGatsbyLink> Специальные условия
                                Лицензии на
                                Опциональную программу - Сервис управления электронными картами «Электронная карта
                                лояльности».</AdaptiveLink></p>

                    </div>
                </div>
            </section>

            <CtaForm
                isFry={false}
                className={pageStyles.pageSection}
                isWhiteBackground
            />
        </DefaultLayout>

    )

}
